export default function leadingZero(number) {
  if (isNaN(number) || number >= 10) {
    return number;
  }

  return `0${number}`;
}
